export function initializeWizardNavigation(options = {}) {
  const wizard = document.querySelector('multistep-wizard')
  const section = options.section || document.querySelector('.test-block')
  const initialPosition = options.initialPosition || 'nivel'

  function updateBackButtonVisibility() {
    const currentStep = wizard.querySelector('multistep-step.shown')
    const prevButtons = document.querySelectorAll('[go="prev"]')

    prevButtons.forEach(btn => {
      btn.style.display = (currentStep && currentStep.getAttribute('position') === initialPosition) ? 'none' : 'block'
    })
  }

  updateBackButtonVisibility()

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class' && mutation.target.classList.contains('shown')) {
        updateBackButtonVisibility()
      }
    })
  })

  wizard.querySelectorAll('multistep-step').forEach(step => {
    observer.observe(step, { attributes: true, attributeFilter: ['class'] })
  })

  const prevListener = (evt) => {
    if (evt.target.getAttribute('position') === initialPosition) {
      section.style.display = 'block'
    }
  }

  const nextListener = (evt) => {
    if (evt.target.getAttribute('position') === 'start') {
      section.style.display = 'none'
    }
    updateBackButtonVisibility()
  }

  wizard.addEventListener('prev', prevListener)
  wizard.addEventListener('next', nextListener)
}

// Inicializar cuando el documento esté listo
document.addEventListener('turbo:load', function () {
  const currentPath = window.location.pathname

  // Determinar el valor inicial según la ruta
  let initialPosition
  if (currentPath.match(/\/depositos\/|\/que-deposito-elegir/)) {
    initialPosition = 'importe_inversion'
  } else if (currentPath.match(/\/cuentas\/|\/que-cuenta-elegir/)) {
    initialPosition = 'tipo'
  } else if (currentPath.match(/\/brokers\/|\/que-broker-elegir/)) {
    initialPosition = 'nivel'
  } else {
    initialPosition = 'tipo' // valor por defecto
  }

  initializeWizardNavigation({ initialPosition })
})
